export default "__VITE_ASSET__DmZK42ri__"